import PageCache from 'lib/page-cache';
import 'lib/loader/series';
import 'lib/transforms/series.mapByCode';
import titleSwap from 'lib/transforms/series.year.title.swap';

// see Vehicle-Strip.xsl for supplying this xform with a seriesManager from a DCR
// returns a promise object, since we need to make sure we have mapByCode
export default function seriesManagerXform(seriesManager) {
  return PageCache.await('series.map')
    .then(function (seriesMap) {
      return seriesManager
        .map(item => item[Object.keys(item)[0]]) // Return item that lives at the first prop. Should be item.SeriesManager, but doesn't have to be
        .filter(seriesObj => !BATSiteConfig.disabledVehicles.includes(seriesObj.series)) // Only vehicles not found in BATSiteConfig.disabledVehicles
        .map((item) => {
          let displayName = seriesMap[item.series].series_display_name;
          return {
            displayName: displayName,
            modelYearTitle: titleSwap(item.seriesYear, displayName),
            ...item
          };
        });
    });
}
